import { useEffect, useState } from 'react'
import { CS_URL } from '../constants'
import { ChevronRightIcon } from './icons'

interface Props {
    onStateChange: (isOpen: boolean) => void
}

export const DesktopNav = ({ onStateChange }: Props) => {
    const [servicesOpen, setServicesOpen] = useState(false)
    const [aboutUsOpen, setAboutUsOpen] = useState(false)
    const [supportOpen, setSupportOpen] = useState(false)
    useEffect(() => {
        const isOpen = servicesOpen || aboutUsOpen || supportOpen
        onStateChange(isOpen)
    }, [servicesOpen, aboutUsOpen, supportOpen, onStateChange])

    return (
        <nav className="cs-main-nav nav-desktop js-navigation">
            <div className="navigation-wrapper">
                <div className="navigation" role="navigation">
                    <ul className="cs-main-nav-items navigation-list js-primary-nav-list">
                        <li className="primary-nav-item">
                            <button
                                className="primary-link is-size-5 is-flex is-relative p__0_75 js-primary-link"
                                onClick={() => {
                                    setServicesOpen(!servicesOpen)
                                    setAboutUsOpen(false)
                                    setSupportOpen(false)
                                }}>
                                Services
                                <span className="icon chevron">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fas"
                                        data-icon="chevron-right"
                                        className={`svg-inline--fa fa-chevron-right fa-w-10 ${
                                            servicesOpen
                                                ? 'transform rotate-180'
                                                : ''
                                        }`}
                                        role="img"
                                        viewBox="0 0 320 512">
                                        <path
                                            fill="currentColor"
                                            d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                                        />
                                    </svg>
                                </span>
                            </button>

                            <ul
                                className={`navigation-secondary-list is-flex js-secondary-nav-list transform ${
                                    servicesOpen
                                        ? 'translate-y-8'
                                        : 'translate-y-minus320'
                                }`}>
                                <div className="secondary-list">
                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/courier-services`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Courier services
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/courier-services/same-day-delivery`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Same day courier
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/courier-services/next-day-delivery`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Next day delivery
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/courier-services/international-delivery`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            International delivery
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/courier-services/IT-relocation`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            IT relocation
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/courier-services/contract-runs`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Contract runs
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/courier-services/logistics`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Logistics services
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/courier-services/Freight-services`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Freight
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/courier-services/in-night`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            In-night delivery
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/courier-services/specialist-services`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Specialist services
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href="https://www.citysprintoffice.co.uk/"
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            CitySprint Office
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href="https://www.citysprinthealth.co.uk/"
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            CitySprint Health
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>
                                </div>
                            </ul>
                        </li>
                        <li className="primary-nav-item">
                            <button
                                className="primary-link is-size-5 is-flex is-relative p__0_75 js-primary-link"
                                onClick={() => {
                                    setAboutUsOpen(!aboutUsOpen)
                                    setServicesOpen(false)
                                    setSupportOpen(false)
                                }}>
                                About us
                                <span className="icon chevron">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fas"
                                        data-icon="chevron-right"
                                        className={`svg-inline--fa fa-chevron-right fa-w-10 ${
                                            aboutUsOpen
                                                ? 'transform rotate-180'
                                                : ''
                                        }`}
                                        role="img"
                                        viewBox="0 0 320 512">
                                        <path
                                            fill="currentColor"
                                            d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                                        />
                                    </svg>
                                </span>
                            </button>

                            <ul
                                className={`navigation-secondary-list is-flex js-secondary-nav-list transform ${
                                    aboutUsOpen
                                        ? 'translate-y-8'
                                        : 'translate-y-minus320'
                                }`}>
                                <div className="secondary-list">
                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/about-us`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Who we are
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/about-us/our-vision`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Our vision
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/about-us/our-people`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Our people
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/about-us/csr/green`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Environmentally friendly delivery
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/about-us/our-fleet`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Our fleet
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/about-us/our-customers`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Our customers
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/about-us/case-studies`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Case studies
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/about-us/awards-and-accreditations`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Awards
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/about-us/national-coverage`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            National coverage
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/about-us/csr`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            CSR
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/about-us/sell-your-business`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Selling your business?
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/about-us/technology`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Technology
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href="https://careers.citysprint.co.uk"
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Careers
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>
                                </div>
                            </ul>
                        </li>
                        <li className="primary-nav-item">
                            <button
                                className="primary-link is-size-5 is-flex is-relative p__0_75 js-primary-link"
                                onClick={() => {
                                    setSupportOpen(!supportOpen)
                                    setAboutUsOpen(false)
                                    setServicesOpen(false)
                                }}>
                                Support
                                <span className="icon chevron">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fas"
                                        data-icon="chevron-right"
                                        className={`svg-inline--fa fa-chevron-right fa-w-10 ${
                                            supportOpen
                                                ? 'transform rotate-180'
                                                : ''
                                        }`}
                                        role="img"
                                        viewBox="0 0 320 512">
                                        <path
                                            fill="currentColor"
                                            d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                                        />
                                    </svg>
                                </span>
                            </button>

                            <ul
                                className={`navigation-secondary-list is-flex js-secondary-nav-list transform ${
                                    supportOpen
                                        ? 'translate-y-8'
                                        : 'translate-y-minus320'
                                }`}>
                                <div className="secondary-list">
                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/account/activate-your-online-account`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Activate your online account
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/contact-us`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Contact us
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/payment-options`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Payments & charges
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/track`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Track
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/support/resources`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Guides & resources
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/brexit`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Brexit guidance
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>

                                    <li className="nav-list-item is-flex">
                                        <a
                                            href={`${CS_URL}/locations-lookup`}
                                            className="secondary-link has-text-weight-bold is-size-5 is-flex">
                                            Find my local service centre
                                            <span className="icon chevron">
                                                <ChevronRightIcon />
                                            </span>
                                        </a>
                                    </li>
                                </div>
                            </ul>
                        </li>

                        <li className="primary-nav-item">
                            <a
                                href={`${CS_URL}/account/sign-in`}
                                className="primary-link is-size-5 is-flex is-relative p__0_75">
                                Sign in
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}
